import { Radio, ExternalLink, Info, FileText, MapPinned } from "lucide-react";

const BRIEFINGS = [
  { label: "NAIPS Internet Service — Login", url: "https://www.airservicesaustralia.com/naips/", desc: "Pre-flight briefings, NOTAMs, MET" },
  { label: "Register a free NAIPS account", url: "https://www.airservicesaustralia.com/naips/Account/Register", desc: "Required for briefing access" },
  { label: "Flight Briefing (Airservices)", url: "https://www.airservicesaustralia.com/industry-info/flight-briefing/", desc: "How briefings work" },
  { label: "Flight Briefing Data Product", url: "https://data.airservicesaustralia.com/data-product/flight-briefing-data", desc: "SOAP web service for developers" },
];

const PRODUCTS = [
  "Location Briefing (single aerodrome / area)",
  "Area Briefing (met + NOTAM for a briefing area)",
  "Specific Pre-Flight Information Bulletin (SPFIB) for a route",
  "General Aviation Met Forecasts (ARFOR / TAF / METAR)",
  "GPS RAIM prediction",
  "Flight Notification (SARTIME)",
];

export default function NaipsPage() {
  return (
    <div className="space-y-6 fade-up max-w-5xl">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-lime-600 mb-1">Airservices Australia</p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 font-heading flex items-center gap-2">
          <Radio className="h-8 w-8 text-lime-500" /> NAIPS
        </h1>
        <p className="text-slate-500 mt-1">National Aeronautical Information Processing System — pre-flight briefings &amp; aeronautical data.</p>
      </div>

      <div className="bg-sky-50 border border-sky-200 rounded-xl p-4 flex gap-3">
        <Info className="h-5 w-5 text-sky-600 shrink-0 mt-0.5" />
        <div className="text-sm text-slate-700">
          <p className="font-medium text-slate-900">Integration note</p>
          <p className="mt-1">Airservices does not offer a public REST API. Briefing &amp; NOTAM data is available via the NAIPS <strong>SOAP web service</strong>, which requires a registered NAIPS account and a signed data agreement. Once credentials are supplied, this section can pull live area briefings &amp; NOTAMs automatically. For now, use the quick links below to log in and generate a briefing.</p>
        </div>
      </div>

      <section className="bg-white border border-slate-200 rounded-xl p-6">
        <h2 className="text-lg font-semibold font-heading text-slate-900 mb-4 flex items-center gap-2"><MapPinned className="h-5 w-5 text-lime-500" /> Quick access</h2>
        <div className="grid sm:grid-cols-2 gap-3">
          {BRIEFINGS.map((l) => (
            <a key={l.url} href={l.url} target="_blank" rel="noopener noreferrer" data-testid="naips-link"
              className="flex items-center justify-between gap-2 p-3 rounded-lg border border-slate-200 hover:border-lime-300 hover:bg-lime-50/50 transition-all">
              <span><span className="text-sm font-medium text-slate-800 block">{l.label}</span><span className="text-xs text-slate-500">{l.desc}</span></span>
              <ExternalLink className="h-4 w-4 text-slate-400 shrink-0" />
            </a>
          ))}
        </div>
      </section>

      <section className="bg-white border border-slate-200 rounded-xl p-6">
        <h2 className="text-lg font-semibold font-heading text-slate-900 mb-4 flex items-center gap-2"><FileText className="h-5 w-5 text-lime-500" /> Available briefing products</h2>
        <ul className="grid sm:grid-cols-2 gap-2">
          {PRODUCTS.map((p) => (
            <li key={p} className="flex items-start gap-2 text-sm text-slate-700">
              <span className="h-1.5 w-1.5 rounded-full bg-lime-500 mt-2 shrink-0" /> {p}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
